/* Ocean Racing product cards (ntd-card.js), North Track Digital, 2026-10-08.
   Colour swatch clicks swap the card image, the hover image and the links in place, on every card
   (homepage rows, collections, search, "Goes with it", "You may also like"). Loaded by card-product.liquid.
   Moved here from ntd-enhancements.js, which only loaded with the cart drawer. */
(function () {
  'use strict';
  if (window.__ntdCard) return;
  window.__ntdCard = true;

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('.ntd-card-swatch');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();

    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    var imgs = card.querySelectorAll('.card__media .media > img');
    var main = imgs[0];
    var hover = imgs[1];
    var src = swatch.getAttribute('data-ntd-image');
    if (main && src) {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = src;
    }
    /* The hover image follows the colour unless the product has a fixed lifestyle hover (ntd.hover_image). */
    if (hover && hover.getAttribute('data-ntd-fixed') !== 'true') {
      var h = swatch.getAttribute('data-ntd-hover') || src;
      if (h) {
        hover.removeAttribute('srcset');
        hover.removeAttribute('sizes');
        hover.src = h;
      }
    }

    var url = swatch.getAttribute('data-ntd-url');
    if (url) {
      card.querySelectorAll('a.full-unstyled-link, .card__media a').forEach(function (a) { a.href = url; });
    }

    card.querySelectorAll('.ntd-card-swatch').forEach(function (b) { b.classList.remove('is-active'); });
    swatch.classList.add('is-active');
  });
})();
